
<modal-window :mainWidth="12">
  <h1>Add a new Special Occurrence</h1>

  <div class="label mt-3 mb-1">Owner Board</div>

  <v-select
    :options="occurrenceStore.possibleOwnerBoards"
    label="title"
    :clearable="false"
    :reduce="(board) => board.id"
    placeholder="Select owner board"
    v-model="occurrence.ownerBoardId"
  ></v-select>

  <div class="label mt-3 mb-1">Type</div>
  <v-select
    :options="availableTypes"
    label="type"
    :clearable="false"
    :reduce="(type) => type"
    placeholder="Please select a occurrence type..."
    v-model="occurrence.type"
  ></v-select>

  <div class="mb-2 mt-3" v-if="occurrence.type !== 'MaterialRequest'">
    <div class="label mt-2 mb-1">Special Occurrence Name</div>
    <input type="text" class="form-control" v-model="occurrence.name" />
  </div>

  <div class="mt-3 d-flex justify-content-between align-content-center">
    <div class="so-btn">
      <button class="btn btn-block btn-sm btn-secondary" @click="cancel()">Cancel</button>
    </div>
    <div class="so-btn">
      <button class="btn btn-block btn-sm btn-success" :disabled="!canAdd" @click="addOccurrence()">
        <i class="far fa-save"></i>
        Add Special Occurrence
      </button>
    </div>
  </div>
</modal-window>
